import { ComponentTypeEnum } from "@/graphql";

const componentTypePath: Partial<Record<ComponentTypeEnum, string>> = {
  [ComponentTypeEnum.ActionItem]: "action-roleplays",
  [ComponentTypeEnum.Article]: "articles",
  [ComponentTypeEnum.Video]: "videos",
  [ComponentTypeEnum.AiRoleplay]: "ai-roleplays",
  [ComponentTypeEnum.Survey]: "surveys",
  [ComponentTypeEnum.OneOneCoachingMaster]: "one-one-coaching",
};

interface GetProgramComponentPathProps {
  type?: ComponentTypeEnum;
  programId?: string;
  componentId?: string;
  responseId?: string | null;
}

export function getProgramComponentPath({
  type,
  programId,
  componentId,
  responseId,
}: GetProgramComponentPathProps) {
  if (!programId) return "";

  let path = `/programs/${programId}`;
  if (type) path += `/${componentTypePath[type]}`;
  if (componentId) path += `/${componentId}`;
  if (responseId) path += `/${responseId}`;

  return path;
}
